import { useState } from "react";
import API from "../api/api";
import ArticleCard from "../components/ArticleCard";
import SEO from "../seo";

export default function Search() {
  const [query, setQuery] = useState("");
  const [result, setResult] = useState([]);

  const search = () => {
    API.get(`/articles/search/${query}`).then((res) => setResult(res.data));
  };

  return (
    <div className="p-6">
      <SEO title="Search Articles" description="Search tech articles by keywords" />

      <input
        type="text"
        onChange={(e) => setQuery(e.target.value)}
        className="theme-border p-2 rounded"
        placeholder="Search something..."
      />

      <button
        onClick={search}
        className="bg-blue-600 text-white px-4 py-2 rounded mt-3"
      >
        Search
      </button>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        {result.map((a) => <ArticleCard key={a.id} article={a} />)}
      </div>
    </div>
  );
}
